import { createServerFn } from '@tanstack/react-start';
import { defineQuery } from 'groq';

import type { TermsOfUseQueryResult } from '@/sanity.types';

import { createSanityClient } from './client';
import { legalDocumentProjection } from './legal-document';

export type TermsOfUse = NonNullable<TermsOfUseQueryResult>;

const termsOfUseQuery = defineQuery(`*[
  _type == "termsOfUse" &&
  _id == "termsOfUse"
][0] ${legalDocumentProjection}`);

/** Public server function: it only reads the published terms of use from Sanity. */
export const getTermsOfUse = createServerFn({ method: 'GET' }).handler(
  async (): Promise<TermsOfUse | null> => {
    const client = createSanityClient();

    try {
      return await client.fetch(termsOfUseQuery);
    } catch (error) {
      console.error('Failed to load Sanity terms of use', error);
      return null;
    }
  },
);
